/* eslint-disable import/prefer-default-export */
import { useRef } from 'react';

/**
 * FormInputWithPrecisionDisplay re-reads `object[fieldName]` into its own
 * editing buffer whenever `object`'s identity changes — a fresh literal
 * every render wipes out in-progress text (e.g. a typed-but-uncommitted
 * "."). One stable object per field, only re-synced when Formik's number
 * actually differs from it, keeps that text authoritative.
 */
export const useStableFieldBuffer = () => {
  const fieldBufferRef = useRef<Record<string, number | string | null>>({});

  return (fieldName: string, formikValue: number | null) => {
    const buffer = fieldBufferRef.current;
    const buffered = buffer[fieldName];
    const bufferedNum = Number(
      typeof buffered === 'string' ? buffered.replaceAll(',', '') : buffered
    );
    if (buffered === undefined || bufferedNum !== (formikValue ?? 0)) {
      buffer[fieldName] = formikValue;
    }
    return buffer;
  };
};
